import { useEffect, useState } from 'react'
import API from '../../../api'
import { useSelector } from 'react-redux'
import setQuery from 'set-query-string'
import { courseType } from '../CardsDsl/CourseCard/CourseCardDsl'

let controller, signal

const useCoursesList = (diveCenterId, inViewport, enterCount) => {
  const isMobile = () => window.innerWidth < 768
  const [isLoading, setIsLoading] = useState(false)
  const [isShowPlaceholder, setIsShowPlaceholder] = useState(false)
  const [params, setParams] = useState({ page: 1, pageSize: isMobile() ? 1 : 4 })
  const [isNextPageAvailable, setIsNextPageAvailable] = useState(false)
  const [isAllowLoad, setIsAllowLoad] = useState(false)
  const [total, setTotal] = useState(0)
  const queryFilters = useSelector(
    (state) => state.queryFilters,
    (a, b) => JSON.stringify(a) === JSON.stringify(b),
  )
  const [courses, setCourses] = useState([])

  useEffect(() => {
    setIsAllowLoad((p) => p ? true : inViewport)
  }, [inViewport])

  useEffect(() => {
    setQuery(queryFilters)
    fetchData()
    return () => {
      controller && controller.abort()
    }
  }, [queryFilters, params, isAllowLoad])

  useEffect(() => {
    setParams({ page: 1, pageSize: isMobile() ? 1 : 4 })
    setIsShowPlaceholder(true)
  }, [queryFilters])

  const fetchData = async (listParams) => {
    setIsLoading(true)
    if(!isAllowLoad) {
      return { courses }
    }
    setIsShowPlaceholder(true)
    const eLearning = []
    const paper = []
    const adventure = []
    if('AbortController' in window) {
      controller = new window.AbortController()
      signal = controller.signal
    }
    const filter = { uniq_activity: true, ...params, ...listParams, ...queryFilters }
    API(
      `/api/adventure/v1/dive-centers/${diveCenterId}/activities/courses/`,
      signal,
    )
      .get(filter)
      .then(({ count, results, next }) => {
        if(!results) {
          setCourses((prevState) => prevState)
          return
        }
        setIsNextPageAvailable(Boolean(next))
        setTotal(count)
        results.forEach((item, index) => {
          const {
            isPaperCard3,
            isPaperCard2,
            isPaperCard,
            isElearningCard,
          } = courseType(item)
          if(item.adventure) {
            item.adventure.position = index + 1
            adventure.push(item)
          } else if(item.diveCourseInfo) {
            item.diveCourseInfo.position = index + 1
          }
          if(isElearningCard) {
            eLearning.push(item)
          } else if(isPaperCard || isPaperCard2 || isPaperCard3) {
            paper.push(item)
          }
        })
        setCourses(results)
      })
      .catch((error) => {
        if(error.name !== 'AbortError') {
          setIsLoading(false)
        }
      })
      .finally(() => {
        setIsLoading(false)
        setIsShowPlaceholder(false)
      })
  }

  return {
    courses,
    total,
    params,
    isLoading,
    setParams,
    fetchData,
    isShowPlaceholder,
    isNextPageAvailable,
  }
}

export default useCoursesList
